export const removeGroups = (groupIDs, kudo) => {
	const groupsToRemove = groupIDs.map(group => group.id);
	const newKudoOrBadge = { ...kudo };
	newKudoOrBadge.groups = newKudoOrBadge.groups.filter(group => !groupsToRemove.includes(group.id));
	return newKudoOrBadge;
};

export const addGroups = (groupIDs, kudo) => {
	const newKudoOrBadge = { ...kudo };
	newKudoOrBadge.groups = [...kudo.groups, ...groupIDs];
	return newKudoOrBadge;
};
